export default "__VITE_ASSET__elj$F50S__"